import {
  observable,
  action,
  computed,
} from 'mobx';
import moment from 'moment-timezone';

class ShipHistoryStore {
  @observable
    historyItems = [];
  @observable
    historyItemId = null;
  @observable
    inventoryItemId = null;
  @observable
    loading = false;
  @observable
    saving = false;
  @observable
    dateFrom = moment()
      .tz(this.timezone)
      .startOf('day')
      .subtract(1, 'month')
      .toDate();
  @observable
    dateTo = moment()
      .tz(this.timezone)
      .endOf('day')
      .toDate();

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  get api() {
    return this.rootStore.newAuthStore;
  }

  get plantId() {
    return this.rootStore.locationsStore.plantId;
  }

  get timezone() {
    return this.rootStore.settingsStore.configuration?.ianaTimeZone;
  }

  @computed
  get material() {
    if (this.inventoryItemId) {
      return this.rootStore.materialStore.getMaterialByInventoryId(this.inventoryItemId);
    }

    return null;
  }

  @action
  loadHistory() {
    this.loading = true;
    const url = `/api/plant/${this.plantId}/inventory/${this.historyItemId}/history`;

    return this.api
      .makeAuthorizedRequest(
        url,
        {
          'date.from': moment(this.dateFrom).tz(this.timezone).format(),
          'date.to': moment(this.dateTo).tz(this.timezone).format(),
          sorting: 'date,desc',
        }
      )
      .then(resp => {
        this.loading = false;
        this.historyItems = resp;
      });
  }

  @action
    shipIn = payload => {
      this.saving = true;
      payload.vendor = payload.vendor || {};
      return this.api
        .makeAuthorizedRequest(
          `/api/plant/${this.plantId}/inventory/${payload.inventoryItemId}/shipIn`,
          {
            inventoryItemId: payload.inventoryItemId,
            date: payload.deliveryTime || moment().tz(this.timezone).format(),
            quantity: payload.quantity,
            binIds: payload.binIds || [],
            comment: payload.comment,
            bolTicket: payload.bolTicket,
            bolQuantity: payload.bolQuantity,
            ticket: payload.ticket,
            truck: payload.truck,
            hauler: payload.hauler,
            vendorId: payload.vendor.id,
            vendorCode: payload.vendor.code,
            vendorName: payload.vendor.name,
            setDeviceBalance: true,
          },
          'PUT'
        )
        .then(data => {
          const { materialStore } = this.rootStore;
          this.saving = false;
          if (this.historyItemId) {
            return this.loadHistory()
              .then(() => this.rootStore.materialStore.loadMaterials());
          }
          materialStore.materials.forEach((v, i) => {
            if (v.itemId === data.itemId) {
              materialStore.materials[i].currentBalance = data.currentBalance;
            }
          });
          materialStore.materials = materialStore.materials.slice();
          materialStore.loadMaterials(false);
          return data;
        });
    };

  @action
    handleChangeFilter = (field, value) => {
      this[field] = value;
      this.loadHistory();
    };

  @action
    showHistory = inventoryItemId => {
      this.historyItemId = inventoryItemId;
      this.loadHistory();
    };

  @action
  reset() {
    this.loading = false;
    this.saving = false;
    this.inventoryItemId = null;
    this.historyItems = [];
  }
}

export default ShipHistoryStore;
